import route from "./route";
// import components from '@/demo/locale/en_US/components';

export default {
  route,
  "about": {
    "review": "Please review before public",
    "buttonPublic": "Public Information",
    "buttonReview": "Review",
    "buttonCancel": "Cancel Edit",
    "language": "Language",
    "createdBy": "Created by",
    "createdAt": "Created at",
    "lastEditedBy": "Last Edited by",
    "lastEditedAt": "Last Edited at"
  },
  "button": {
    "save": "SAVE",
    "import": "IMPORT",
    "edit": "EDIT",
    "enable": "ENABLE",
    "disable": "DISABLE",
    "remove": "REMOVE",
    "cancel": "CANCEL",
    "reload": "RELOAD",
    "close": "CLOSE",
    "change": "CHANGE",
    "confirm": "CONFIRM",
    "copy": "COPY",
    "search": "SEARCH",
    "approve": "APPROVE",
    "invite": "INVITE",
    "inviteUser": "Invite User",
    "approveUser": "Approve User",
    "rejectUser": "Reject User",
    "editUser": "Edit User",
    "enableUser": "Enable User",
    "diableUser": "Disable User",
    "removeUser": "Remove User",
    "resendInvitation": "Resend Invitation",
    "addProduct": "ADD PRODUCT",
    "addInsect": "ADD INSECT",
    "addPackage": "ADD PACKAGE",
    "addTechnique": "ADD TECHNIQUE",
    "addSetpointParameters": "ADD SETPOINT PARAMETER",
    "addLocation": "ADD LOCATION",
    "addLocationUpercase": "ADD LOCATION",
    "update": "UPDATE",
    "addCustomer": "ADD CUSTOMER",
    "editCustomer": "EDIT CUSTOMER",
    "saveChangesCustomer": "SAVE CHANGES",
    "addTreatment": "ADD TREATMENT DB",
    "editTreatment": "SAVE CHANGES",
    "addSetpoint": "ADD SETPOINT",
    "updateProduct": "UPDATE PRODUCT",
    "updateInsect": "UPDATE INSECT",
    "updatePackage": "UPDATE PACKAGE",
    "updateTechnique": "UPDATE TECHNIQUE",
    "updateSetpoint": "UPDATE SETPOINT PARAMETER",
    "addTreatmentRequest": "ADD TREATMENT REQUEST",
    "editTreatmentRequest": "SAVE CHANGES",
    "viewAll": "VIEW ALL",
    "addUnit": "ADD UNIT",
    "addController": "ADD CONTROLLER",
    "saveChangesControllervariable": "SAVE CHANGES",
    "export": "EXPORT",
    "addInstruction": "ADD INSTRUCTION",
    "review": "REVIEW",
    "publicInstruction": "PUBLIC INSTRUCTION",
    "endReview": "END REVIEW",
    "editInstruction": "EDIT INSTRUCTION",
    "deleteInstruction": "DELETE INSTRUCTION",
    "cancelEdit": "CANCEL EDIT",
    "editLocation": "EDIT LOCATION",
    "editUnit": "EDIT UNIT",
    "addMail": "ADD EMAIL",
    "editMail": "EDIT EMAIL",
    "editController": "EDIT CONTROLLER",
    "addEquipment": "ADD EQUIPMENT",
    "addMaintenanceJob": "ADD MAINTENANCE JOB",
    "editMaintenanceJob": "EDIT MAINTENANCE JOB",
    "publicAbout": "PUBLIC INFORMATION",
    "editAbout": "EDIT INFORMATION",
    "editEquipment": "UPDATE EQUIPMENT",
    "saveChanges": "SAVE CHANGES",
    "viewList": "VIEW LIST",
    "continue": "RESET",
    "addFailure": "ADD FAILURE",
    "editFailure": "EDIT FAILURE",
    "exportExcel": "EXPORT EXCEL",
    "addLicense": "ADD LICENSE",
    "reject": "REJECT",
    "previewShipment": "PREVIEW SHIPMENT CERTIFICATE",
    "addRequest": "ADD REQUEST",
    "editRequest": "EDIT REQUEST",
    "activate": "ACTIVATE",
    "changeTemplate": "CHANGE TEMPLATE",
    "addRule": "ADD RULE",
    "select": "SELECT",
    "addRpa": "ADD RPA",
    "editRpa": "EDIT RPA",
    "closeFailure": "CLOSE FAILURE",
    "addUser": "ADD USER",
    "add": "ADD",
    "ACCEPT": "ACCEPT",
    "NEED_SUPPORT": "NEED SUPPORT",
    "REJECT": "REJECT",
    "clearFilter": "CLEAR FILTERS",
    "filter": "FILTER",
  },
  "customer": {
    "view": "View Customer",
    "edit": "Edit Customer",
    "disable": "Disable Customer",
    "enable": "Enable Customer",
    "new": "New Customer"
  },
  "dialog": {
    "removeUser": {
      "title": "Edit User",
      "content": "Are you sure you want to remove user <strong><%= user %></strong> from this group?"
    },
    "userEdit": {
      "title": "Edit User"
    },
    "addUser": {
      "title": "Add User"
    },
    "approve": {
      "title": "Approve User",
      "content": "Please assign group for this user",
      "shipmentCertificate": "Are you sure to approve the shipment certificate <strong>#<%= number %></strong>?",
    },
    "invite": {
      "title": "Invite User",
      "content": "To invite an user, please enter user's email. System will automatically send an email for this user to complete the registration."
    },
    "reject": {
      "content": "Are you sure to reject the user <strong><%= user %></strong> to access the system?",
      "shipmentCertificate": "Are you sure to reject the shipment certificate <strong>#<%= number %></strong>?"
    },
    "disable": {
      "content": "Are you sure to disable the user <strong><%= user %></strong>?"
    },
    "enable": {
      "content": "Are you sure to enable the user <strong><%= user %></strong>?"
    },
    "resetPassword": {
      "content": "Are you sure you want to reset the password for user <strong><%= user %></strong>?"
    },
    "delete": {
      "content": "Are you sure to delete the user <strong><%= user %></strong>?",
      "treatment": "Are you sure to delete the treatment database?",
      "treatmentRequest": "Are you sure to delete the treatment request?",
      "failureTracking": "Are you sure to delete the failure event?",
      "shipmentCertificate": "Are you sure to delete the shipment certificate?",
      "license": "Are you sure to delete the license?",
      "rpa": "Are you sure to delete the RPA?",
      "job": "Are you sure to delete the job?",
    },
    "confirmLocation": {
      "content": "Are you sure to disable the location?",
      "no": "NO",
      "yes": "YES"
    },
    "confirmDisconnectLocation": {
      "content": "Are you sure to disconnect the location?",
      "no": "NO",
      "yes": "YES"
    },
    "confirmMasterList": {
      "contentDisable": "Are you sure to disable the",
      "contentEnable": "Are you sure to enable the",
      "contentDelete": "Are you sure to delete the",
      "errDialog": "This item is used from treatment database."
    },
    "confirmInstruction": {
      "contentDelete": "Are you sure to delete the instruction?"
    },
    "confirmEmail": {
      "contentDelete": "Are you sure to delete the email?"
    },
    "confirmUnit": {
      "contentRemove": "Are you sure to remove the Unit?",
      "contentRemoveController": "Are you sure to remove the Controller?"
    },
    "confirmCustomer": {
      "contentDisable": "Are you sure to disable the customer"
    },
    "viewMember": {
      "content": "Total <%= size %> users in this group of users."
    },
    "continueTreatmentRequest": {
      "content": "The treatment request <strong><%= number %></strong> will continue with new Start Date and End Date.<br />Are you sure to continue the treatment request?"
    },
    "importTreatmentRequest": {
      "content": "Are you sure to import variables?"
    },
    "deleteEquipment": {
      "content": "Are you sure to delete the equipments?"
    },
    "deleteJob": {
      "content": "Are you sure to delete the job?"
    },
    "finishJob": {
      "content": "Are you sure you want to finish this job?"
    },
    "resetOperatingTime": {
      "content": "Are you sure to reset this equipment operating time?"
    },
    "deleteVariable": {
      "content": "Are you sure to delete the variable?"
    },
    "deleteVariables": {
      "content": "Are you sure to delete {number} variable(s)?"
    },
    "removeVariable": {
      "content": "Are you sure to remove the variable?"
    },
    "removeVariables": {
      "content": "Are you sure to remove {number} variable(s)?"
    },
    "redButton": {
      "content1": "Are you sure to start the treatment request?",
      "content2": "Are you sure to stop the treatment request?"
    },
    "notTreatment": {
      "start": "Please create treatment request before starting",
    },
    "greenButton": {
      "content1": "Are you sure to turn on this <strong>{name}</strong>?",
      "content2": "Are you sure to turn off this <strong>{name}</strong>?"
    },
    "start": {
      "treatmentRequest": "Are you sure to start the treatment request?",
    },
    "stop": {
      "treatmentRequest": "Are you sure to stop the treatment request?",
    },
    "close": {
      "failureTracking": "Are you sure to close the failure event?",
    },
    "send": {
      "shipmentCertificate": "Are you sure to send the shipment certificate request?"
    },
    "cancel": {
      "shipmentCertificate": "Are you sure to cancel the shipment certificate request <strong>#<%= number %></strong>?",
    },
  },
  "equipment": {
    "equipmentName": "Equipment Name",
    "totalTime": "Total Time (Hrs)",
    "totalTimeHours": "Total Time (Hours)",
    "operatingTime": "Operating Time (Hrs)",
    "remainingTime": "Remaining Time (Hrs)",
    "file": "File",
    "attachFile": "Attach File",
    "clickToAttach": "Click to attach...",
    "jobs": "JOBS",
    "equipments": "EQUIPMENTS"
  },
  "job": {
    "jobName": "Job Name",
    "file": "File",
    "attachFile": "Attach File",
    "clickToAttach": "Click to attach...",
    "jobs": "JOBS",
    "maintenanceDate": "Maintenance Date",
    "estimatedTimeRemaining": "Estimated Time Remaining",
    "notes": "Notes",
    "newNote": "Add new note",
    "days": "Days",
  },
  "locationColumn": {
    "customerName": "Customer Name",
    "locationName": "Location Name",
    "address": "Address",
    "shipmentAddress": "Shipment Cert Address",
    "timeZone": "Time Zone",
    "localTimeZone": "Location timezone",
    "contact": "Contact",
    "unit": "Unit",
    "device": "Device",
    "createdDate": "Created Date",
    "action": "Action",
    "remark": "Remark",
    "controller": "Controller",
    "status": {
      "Active": "Active",
      "Inactive": "Inactive",
      "All": "All"
    }
  },
  "message": {
    "noRemainProduct": "This product is out of stock",
    "noRequestRequired": "Request Pallet/Weight of product is required",
    "required": "This field is required",
    "invalid": "This field is invalid",
    "email_exist": "This user has the account already.",
    "group_required": "At least one group must be selected.",
    "license_location_duplicated": "Other license of this location has existed.",
    "license_clientKey_duplicated": "Other license of this client key has existed.",
    "locationName_exist": "Location name has existed, please change your location name.",
    "address_exist": "Address has existed, please change your address.",
    "errLocationNameArr": "This location has existed, please check again.",
    "service_unavailable": "Service is unavailable",
    "bad_request": "Bad Request. Please check your form again.",
    "internal_server_error": "Internal Server Error. Please try again later",
    "empty_content_about": "This field is required",
    "item_isUsed": "This item is used from treatment database.",
    "treatmentName_exist": "This item has existed.",
    "err_subject_instruction": "Subject Instruction must be 150 characters or less",
    "max_lenght": "{_field_} may not be greater than {length} characters.",
    "field_required": "{_field_} can not be empty.",
    "field_numberic": "{_field_} must be number.",
    "unitName_exist": "Unit name has existed, please change your unit name.",
    "phoneNumber_numberic": "This field must be a number.",
    "email": "Email must be valid",
    "emailAddress_exist": "Email address has existed.",
    "companyName_exist": "Company Name has existed.",
    "phoneNumber_exist": "Phone Number has existed.",
    "treatment_database_exist": "The set of Product, Package & Technique is duplicated",
    "treatment_request_used": "This Treatment DB is used for a Treatment Request",
    "unit_variable_startstop_duplicate": "The selected unit already had another variable which was ticked Start/Stop",
    "unit_variable_o2up_duplicate": "The selected unit already had another variable which was ticked O2 Up",
    "unit_variable_o2downtime_duplicate": "The selected unit already had another variable which was ticked Remaining O2 Downtime",
    "unit_variable_greenbutton_duplicate": "The selected unit already had another variable which was ticked Green Button",
    "unit_variable_memory_duplicate": "The memory names are duplicated with memory names on system",
    "unit_variable_memory_invalid": "The memory name is invalid",    
    "controller_ipAddress_duplicate": "IP Address should be unique for 1 location",
    "controller_name_duplicate": "Name should be unique for 1 location",
    "blank_variable_name": "There are blank values in the variable name column",
    "blank_variable_memory_name": "There are blank values in the memory name column",
    "blank_variable_type_name": "There are blank values in the type column",
    "invalid_variable_type": "Type can only be Bool / Byte / UByte / Word / Floating / Time",
    "invalid_variable_checkbox": "You can only use x to tick checkbox in the file",
    "treatment_monitoring_red_button_invalid": "This unit does not have variables for Start/Stop and O2 Up",
    "treatment_monitoring_green_button_invalid": "This unit does not have a variable for Green Button",
    "equipment_file_format_invalid": "Format file is invalid",
    "startDate_before_current_endDate": "There is another request in this unit which conflicts with your selected Start date / End date",
    "invalid_start_date": "Start date can't be before the current date",
    "invalid_end_date": "End date can't be before the start date",
    "unit_variable_variablename_duplicate": "Memory should be unique for 1 controller",
    "must_be_at_least_1_setpoint_in_treatment_db": "There must be at least 1 setpoint in treatment database",
    "emailAddress_not_valid": "The specified user email address could not be found",
    "invalid_date_time": "Invalid time",
    "license_expiration_must_after_registration_date": "The Expiration Date must be after the Registration Date",
    "required_template": "There must be at least 1 template in each phase",
    "phase_2_needs_at_least_1_action_for_reaching_setpoint": "Phase 2 needs at least 1 action for Reaching Setpoint",
    "rpa_unit_already_exist": "The selecting unit already had an RPA",
    "already_treatment_in_unit": "There’s already another In-Request or In-Progress Treatment in the unit",
    "auto_stop_invalid": "The Autostop date can’t before the current date",
    "controller_variable_running_treatment" : "This controller’s variables are using for a treatment in a unit",
    "unit_running_treatment": "This unit is having a treatment",
    "unit_variable_inprogress_duplicate": "The selected unit already had another variable which was ticked In Progress",
    "unit_variable_recorddata_duplicate": "The selected unit already had another variable which was ticked Record Data",
    "unit_variable_icon_duplicate": "The selected unit already had another variable which was selected the same icon",
    "unit_is_O2_up": "Unit is being O2 up.",
    "treatment_request_add_weight":"You can’t continue because this canceled treatment is added weight for shipment certificate",
    "already_treatment_in_unit ":"You can’t continue because there’s already another In-Request or In-Progress Treatment in the unit",
    "write_variable_error":"Unable to connect client app. Please check the client network",
    "sync_not_offline_mode":"This location is online mode",
    "sync_has_in_progress_treatments":"This location has In-Progress Treatment",
    "sync_location_not_exist ":"This location not existed",
    "a_bool_variable_can_only_be_ticked": "A bool variable can only be ticked 1 of these columns Alarm / Start stop / O2 Up / Green button / Parameter / C.Parameter (In progress and Alarm cannot be ticked together )",
    "a_bool_variable_can_not_be_ticked_home_remainingO2DownTime": "A bool variable can’t be ticked Home / Remaining O2 Down Time",
    "a_byte/floating_variable_can_only_be_ticked": "A Byte / UByte / Word / Floating variable can’t be ticked 1 of these columns Alarm / Start stop / O2 Up / Green button / Operation time / In progress / Record data / Remaining O2 Down Time",
    "a_time_variable_can_only_be_ticked": "A Time variable can’t be ticked 1 of these columns Alarm / Start stop / O2 Up / Green button / Operation time / In progress / Record data / Home / Graph",
    "unit_variable_icon_invalid_type": "New bool variables are selected icon.",
    "variable_unit_running": "This variable belongs to unit which is running a treatment",
    "expiry_time_must_have_the_same_among_records": "This product already existed at another Treatment DB record so they must have the same expiry time",
    "invalid_location_connection": "Unable to connect client app. Please check the client network.",
    "check_session_fail": "Failed to check login session. <br/>Please contact your administrator to make sure you have the right permission",
    "invite": "You don't have permission to invite users. Please contact your admin to grant share permission for your account",
    "user-not-found": "User not found",
  },
  "notification": {
    "type": {
      "TREATMENT_CREATED": "Location {locationName}: The treatment request <span class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\">{treatmentNumber}</span> has been created at {dateTime}",
      "TREATMENT_UPDATED": "The treatment request <span class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\">{treatmentNumber}</span> has been cancelled at {dateTime} because the current In-Progress treatment in the same unit has been extended the treatment time",
      "TREATMENT_CONTINUE_AFTER_CANCELING": "The treatment request <span class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\">{treatmentNumber}</span> has been cancelled at {dateTime} because another Cancelled treatment in the same unit has been continued & extended the treatment time",
      "TREATMENT_CONTINUE": "The treatment request <span class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\">{treatmentNumber}</span> has been continued at {dateTime}",
      "TREATMENT_START": "Location {locationName}: The treatment request <span code=\"TREATMENT_START\" class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\" unitId=\"{unitId}\" >{treatmentNumber}</span> has been started at {dateTime}",
      "TREATMENT_STOP": "Location {locationName}: The treatment request <span code=\"TREATMENT_STOP\" class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\" unitId=\"{unitId}\" >{treatmentNumber}</span> has been stopped at {dateTime}",
      "TREATMENT_FINISH": "Location {locationName}: The treatment request <span class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\">{treatmentNumber}</span> has been stopped at {dateTime}",
      "ALARM_ON": "Location {locationName}: <span class=\"todo\">{variableName}</span> in <span class=\"todo\">{unitName}</span> at <span>{dateTime}</span>; <span class=\"todo\">{recommendedAction}</span>",
      "ALARM_OFF": "Location {locationName}: <span class=\"todo\">{variableName}</span> has been turned off in <span class=\"todo\">{unitName}</span> at <span>{dateTime}</span>",
      "TREATMENT_MONITORING_RECOUNTING": "Location {locationName}: There's a failure at {dateTime} that need to recount treatment time for treatment <span code=\"TREATMENT_RECOUNT\" class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\" unitId=\"{unitId}\" >{treatmentNumber}</span>",
      "TREATMENT_MONITORING_REACHED": "Location {locationName}: The treatment <span code=\"TREATMENT_REACHED\" class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\" unitId=\"{unitId}\" >{treatmentNumber}</span> has reached the setpoint {setPointName} at {dateTime}",
      "TREATMENT_MONITORING_EXPECTED_END_DATE": "Location {locationName}: The expected end date of the treatment <span code=\"TREATMENT_REACHED_ALL\" class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\" unitId=\"{unitId}\" >{treatmentNumber}</span> is {dateTime}",
      "TREATMENT_MONITORING_TECHNICAL_CHECKING": "Location {locationName}: There's a technical failure of treatment <span class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\">{treatmentNumber}</span> in {unitName} at {dateTime}. Phase {phase} - {ruleName} - {action}.",
      "TREATMENT_MONITORING_STOP_UNIT": "{unitName} in location {locationName} has been finished at {dateTime}",
      "TREATMENT_MONITORING_WAITING_FOR_TECHNICAL_CHECKING": "Location {locationName}: There's a failure of treatment <span class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\">{treatmentNumber}</span> at {dateTime}. Please wait for a technical checking before starting treatment in {unitName}. Phase {phase} - {ruleName} - {action}.",
      "CONTROLLER_DISCONNECTION": "The location {locationName} has been disconnected with controller {controllerName} at {dateTime}",
      "TREATMENT_MONITORING_OUT_OF_REACH":"Location {locationName}: The treatment <span code=\"TREATMENT_OUT_OF_REACH\" class=\"tw-cursor-pointer color-primary treatment-notification\" treatmentId=\"{treatmentId}\" unitId=\"{unitId}\" >{treatmentNumber}</span> has been out of reach the setpoint {setPointName} at {dateTime}",
      "CONTROLLER_RECONNECTION":"The location {locationName} has been reconnected with controller {controllerName} at {dateTime}",
      "LOCATION_MAINTENANCE_DATE":"Location {locationName} needs to be maintained on {dateTime}",
      "EQUIPMENT_MAINTENANCE_DATE":"Location {locationName}: Remaining time of equipment {equipmentName} is about {equipmentRemainingTime} hrs at {dateTime}",
      "JOB_MAINTENANCE":"Location {locationName} needs to be maintained on {maintenanceDate} with job name is {jobName}",
      "CLIENT_APP_RECONNECTION":"The location {locationName} has been reconnected with ECO2 Server at {dateTime}",
      "CLIENT_APP_DISCONNECTION":"The location {locationName} has been disconnected with ECO2 Server at {dateTime}",
      "FAIL_WRITE_TO_PLC":"Location {locationName}: Failed to update the value: {value} of parameter {variableName} on {unitName} at {dateTime}. The previous value has been kept since writing to PLC fails.",
    }
  },
  "page": {
    "user": {
      "status": {
        "NEW": "New",
        "ACTIVE": "Active",
        "INACTIVE": "Inactive",
        "INVITED": "Invited"
      },
      "organization": {
        "CLIENT": "Client",
        "ECO2": "Eco2"
      }
    },
    "group": {
      "ADMINISTRATOR": "Administrator",
      "MANAGER": "Manager",
      "TECHNICIAN": "Technician",
      "OPERATOR": "Operator",
      "CLIENT": "Client",
      "SPECIAL_EDITOR": "Special Editor",
      "Administrator": "Administrator",
      "Manager": "Manager",
      "Technician": "Technician",
      "Operator": "Operator",
      "Client": "Client",
      "Client_Request": "Client_Request",
      "Client shipment": "Client shipment"
    },
    "permission": {
      "CUSTOMER_MANAGEMENT": "Customer Management",
      "CUSTOMER_MANAGEMENT|ACTIVATE_DEACTIVATE": "Active/Deactivate",
      "LOCATION_MANAGEMENT": "Location Management",
      "LOCATION_MANAGEMENT|ACTIVATE_DEACTIVATE": "Active/Deactivate",
      "UNIT_MANAGEMENT": "Unit Management",
      "UNIT_MANAGEMENT|CALIBRATION_PARAMETERS": "Calibration parameters",
      "UNIT_MANAGEMENT|SETUP_PARAMETERS": "Setup parameters",
      "USER_MANAGEMENT": "User Management",
      "USER_MANAGEMENT|ASSIGN_LOWER_ROLE": "Assign lower role",
      "USER_MANAGEMENT|ACTIVATE_DEACTIVATE": "Active/Deactivate",
      "TREATMENT_DATABASE_MANAGEMENT": "Treatment Database Management",
      "DEVICE_MANAGEMENT": "(PLC) Device Management",
      "TREATMENT_MANAGEMENT": "Treatment Management",
      "TREATMENT_MANAGEMENT|START_STOP_CONTINUE": "Start/Stop/Continue",
      "TREATMENT_MANAGEMENT|VIEW_CERTIFICATE": "View Certificate",
      "TREATMENT_MANAGEMENT|EDIT_FINISHED_REQUEST": "Edit Finished Treatment Request",
      "TREATMENT_MONITORING_FOR_UNIT": "Treatment Monitoring for Unit",
      "TREATMENT_MONITORING_FOR_UNIT|UPDATE_PARAMETERS": "Update parameters",
      "TREATMENT_MONITORING_FOR_UNIT|UPDATE_C_PARAMETERS": "Update c.parameters",
      "TREATMENT_MONITORING_FOR_UNIT|RED_BUTTON": "Red button",
      "TREATMENT_MONITORING_FOR_UNIT|GREEN_BUTTON": "Green button",
      "TREATMENT_MONITORING_FOR_UNIT|RECOUNT_TREATMENT_TIME": "Recount treatment time",
      "FAILURE_TRACKING_MANAGEMENT": "Failure Tracking Management",
      "FAILURE_TRACKING_MANAGEMENT|EXPORT": "Export",
      "MAINTENANCE_TRACKING_MANAGEMENT": "Maintenance Tracking Management",
      "MAINTENANCE_TRACKING_MANAGEMENT|EXPORT": "Export",
      "FCM_PUSH_NOTIFICATION_MANAGEMENT": "FCM Push Notification Management (Mobile)",
      "NOTIFICATION_MANAGEMENT": "Receive Notification",
      "MAILING_LIST_MANAGEMENT": "Mailing List Management",
      "SHIPMENT_CERTIFICATE_REPORTS": "Shipment Certificate Reports (FM04, FM05, FM06)",
      "SHIPMENT_CERTIFICATE_REPORTS|APPROVE_REJECT": "Approve/Reject",
      "LICENSE_MANAGEMENT": "License Management",
      "LICENSE_MANAGEMENT|ACTIVATE_DEACTIVATE": "Active/Deactivate",
      "ACTIVITY_LOGS": "Activity Logs",
      "OPERATION_INSTRUCTION": "Operation Instruction (Blogs)",
      "INFORMATION_PAGES": "RPA Management",
      "DASHBOARD_AND_REPORTS": "Dashboard and Reports",
      "ABOUT_PAGE": "About Page (Public Page)",
      "GROUP_MANAGEMENT": "Group Management",
      "CONTROLLER_MANAGEMENT": "Controller Management",
      "VARIABLES_MANAGEMENT": "Variables Management",
      "VARIABLES_MANAGEMENT|IMPORT_EXPORT": "Import/Export",
      "RPA_MANAGEMENT": "RPA Management",
      "RPA_MANAGEMENT|COPY": "Copy",
      "RECEIVE_NOTIFICATION": "Receive Notification",
      "LICENSE": "License",
      "LICENSE_LIST": "License List",
      "ONLINE_MODE": "Online Mode",
      "ONLINE_MODE|ACTIVE": "Active",
      "LICENSE|ACTIVE": "Active",
      "WEB_CONFIG": "Web Config",
    }
  },
  "text": {
    "DAYS": "Days",
    "HOURS": "Hours",
    "MINUTES": "Minutes",
    "MONTHS": "Months",
    "O2Level": "O2 Level",
    "RPA": "RPA",
    "WEEKS": "Weeks",
    "aboutUs": "About Us",
    "action": "Action",
    "active": "Active",
    "addController": "Add Controller",
    "addEquipment": "Add Equipment",
    "addMaintenanceJob": "Add Maintenance Job",
    "editMaintenanceJob": "Edit Maintenance Job",
    "maintenanceDate": "Maintenance Date",
    "finishJob": "Finish job",
    "addInsect": "Add Insect",
    "addLocationText": "Add Location to Customer",
    "addMail": "Add Mail",
    "addPackage": "Add Package",
    "addProduct": "Add Product",
    "addSetpoint": "Add Setpoint",
    "addSetpointPara": "Add Setpoint Parameter",
    "addTechnique": "Add Technique",
    "addUnit": "Add Unit",
    "addVariable": "Add Variable",
    "addVariablesTo": "Add Variables to",
    "address": "Address",
    "airTempt": "Air Tempt",
    "alarm": "Alarm",
    "all": "All",
    "allVariable": "ALL VARIABLES",
    "approved": "Approved",
    "assignProductsToEachUnit": "Assign products to each Unit",
    "atTime": "at",
    "basicInformationForThisTreatment": "Specific location for this treatment",
    "by": "By",
    "calibrationParameter": "C. Parameters",
    "cancelled": "Cancelled",
    "changeGroupName": "Change Group Name",
    "changeName": "Change Name",
    "changeStatus": "Change Status",
    "changeStatusDescription": "Allow switching status between 'Finished' and 'Cancelled'",
    "additionalInformation": "Additional Information",
    "editFinishedRequestFields": "Edit fields for finished requests",
    "clickToView": "CLICK TO VIEW",
    "clickToViewLowerCase": "Click to view",
    "companyName": "Company Name",
    "confirm": "Confirmation Popup",
    "contact": "Contact",
    "content": "CONTENT",
    "contentLicense": "CONTENT",
    "continue": "Continue",
    "continueTreatment": "Continue Treatment",
    "controller": "Controller",
    "controllerDescription": "Description",
    "controllerName": "Name",
    "controllerVariableMemory": "Memory",
    "controllerVariableName": "Name",
    "controllers": "Controllers",
    "country": "Country",
    "create": "Create",
    "createdAt": "CREATED AT",
    "createdBy": "Created by",
    "createdDate": "Created Date",
    "customer": "Customer",
    "dateClosed": "Date Closed",
    "dateOpen": "Date Open",
    "delete": "Delete",
    "disable": "Disable",
    "disconnect": "Disconnect",
    "edit": "Edit",
    "editController": "Edit Controller",
    "editEquipment": "Edit Equipment",
    "editMail": "Edit Mail",
    "editUnit": "Edit Unit",
    "editVariable": "Edit Variable",
    "email": "Email",
    "emailAddress": "Email Address",
    "enable": "Enable",
    "endDate": "End Date",
    "error": "Error",
    "expectedEndDate": "Expected End Date",
    "failureEvents": "Failure Events",
    "failureName": "Failure Name",
    "faxNumber": "Fax Number",
    "finished": "Finished",
    "finishedTreatments": "Finished Treatments",
    "format": "Format",
    "fromDate": "From Date",
    "fullName": "Name",
    "function": "Function",
    "generalInformation": "Client Information",
    "greenButton": "Green Button",
    "group": "Group",
    "groupName": "Group Name",
    "headTitle": "Header Title",
    "headerImageUrl": "Header Image URL",
    "home": "Home",
    "icon": "Icon",
    "inProgress": "In Progress",
    "inRequest": "In Request",
    "inactive": "Inactive",
    "information": "Information",
    "inletTempt": "Inlet Tempt",
    "insect": "Insect",
    "insectName": "Insect Name",
    "instructionSubject": "Instruction Subject",
    "instructions": "Instructions",
    "ipAddress": "IP Address",
    "ipAddressAndController": "IP Address & Controller",
    "keyword": "Keyword",
    "keywordSearch": "Search by keywords...",
    "keywords": "Keywords",
    "language": "Language",
    "lastEdited": "Last Edited By",
    "lastEditedAt": "Last Edited at",
    "lastEditedBy": "Last Edited by",
    "learnMore": "Learn more",
    "location": "Location",
    "locationName": "Location Name",
    "locationSearch": "Customer Name, Location Name, Address",
    "locations": "LOCATIONS",
    "lotBatchNumbers": "Lot/Batch Numbers",
    "mailAlarm1": "Start/stop/continue/cancel treatment",
    "mailAlarm2": "Reaching setpoints / Expected end time",
    "mailAlarm3": "Alarms",
    "mailCustomer": "Customer",
    "mailLocation": "Location",
    "mailingList": "Mailing List",
    "members": "Members",
    "monitoringSearchRequired": "Please select customer/location to view unit.",
    "monitoringSearchText": "Select which customer/location to view",
    "myProfile": "My Profile",
    "no": "No.",
    "notificationType": "Notification Type",
    "notifyWhen": "NOTIFY WHEN:",
    "packaging": "Packaging",
    "numberOfPackages": "Number of Packages",
    "numberOfPallets": "Number of Pallets",
    "specificationOfProduct": "Specification of Product",
    "o2Up": "O2 Up",
    "operationTime": "Operation time",
    "organization": "Organization",
    "organizations": "Organizations",
    "package": "Package",
    "packageName": "Package Name",
    "parameter": "Parameter",
    "permissions": "Permissions",
    "phoneNumber": "Phone Number",
    "treatmentAddress": "Treatment Address",
    "product": "Product",
    "productInformation": "Product Information",
    "productName": "Product Name",
    "productTempt": "Product Tempt",
    "profileImage": "User Photo",
    "read": "Read",
    "readonly": "Read only",
    "recommendedActions": "Recommended Actions",
    "rejected": "Rejected",
    "remainingO2DownTime": "Remaining Time",
    "remark": "Remark",
    "removeUnit": "Remove Unit",
    "search": "Search",
    "searchLabelCustomer": "Company Name, Email, Address, Phone Number, ...",
    "setpoint": "Setpoint",
    "setpointName": "Setpoint Name",
    "setpointNamePara": "Setpoint Parameter Name",
    "setpointParameters": "Setpoint Parameters",
    "shipmentCertificates": "Shipment Certificates",
    "shipmentCertifications": "Shipment Certifications",
    "shortDescription": "Short Description",
    "specialRequest": "Special Request",
    "start": "Start",
    "startTreatment": "Start treatment request",
    "startDate": "Start Date",
    "startStop": "Start / Stop",
    "status": "Status",
    "stop": "Stop",
    "taxID": "Tax ID",
    "technique": "Technique",
    "techniqueName": "Technique Name",
    "thisSectionWillDetermineWhichSetpointIsFitForTheProduct": "This section will determine which setpoint is fit for the product",
    "titlePublicInstruction": "Please review the instruction before public",
    "toDate": "To Date",
    "total": "Total",
    "totalCustomers": "Total Customers",
    "totalLocations": "Total Locations",
    "totalUnits": "Total Units",
    "totalWeightKG": "Total Weight(KG)",
    "treatmentInRequest": " In Request Treatments",
    "treatmentNR": "Treatment NR.",
    "treatmentRequests": "Treatment Requests",
    "originals": "Originals",
    "treatmentTime": "Treatment Time",
    "treatmentType": "Treatment Type",
    "treatmentsInProgress": "In Progress Treatments",
    "type": "Type",
    "unit": "Unit",
    "units": "Units",
    "unitDescription": "Description",
    "unitName": "Name",
    "unitNameText": "Unit Name",
    "unitType": "Type",
    "zone": "Zone",
    "noneTreatment": "None treatment",
    "update": "Update",
    "updateInsect": "Edit Insect",
    "updateLocationText": "Edit Location",
    "updatePackage": "Edit Package",
    "updateProduct": "Edit Product",
    "updateSetpoint": "Edit Setpoint Parameter",
    "updateTechnique": "Edit Technique",
    "updatedDate": "Updated Date",
    "userGroup": "User Group",
    "users": "Users",
    "variable": "Variable",
    "variableName": "Variable Name",
    "variableToAdd": "VARIABLES TO ADD",
    "variables": "Variables",
    "view": "View",
    "viewCertificate": "View Certificate",
    "viewLocation": "View Location",
    "viewPermissions": "View permissions",
    "viewUsers": "View Users",
    "parameterOfUnit": "",
    "parameterOfController": "",
    "Normal": "Standard",
    "Special": "Special",
    "Closed": "Closed",
    "Open": "Open",
    "lastChangedBy": "Last Changed By",
    "describe": "Describe",
    "causeOfFailure": "Cause of Failure",
    "solution": "Solution",
    "close": "Close",
    "basicInformationForThisFailureEvent": "Basic information for this Failure Event.",
    "failureInformation": "Failure Information",
    "failureEventRelatedInformationAndMore": "Failure Event related information and more.",
    "objectName": "Event",
    "oldValue": "Old Value",
    "newValue": "New Value",
    "dateTime": "Time",
    "eventInitiated": "User",
    "licenseNumber": "License Number",
    "expirationDate": "Expiration Date",
    "isSendOfflineMail": "Send Offline Mail",
    "addLicense": "Add License",
    "editLicense": "Edit License",
    "certificateId": "Cert ID",
    "treatmentId": "Treatment ID",
    "totalUndercertificatedWeight": "Total Undercertificated Weight(KG)",
    "requestWeight": "Request Weight (KG)",
    "remainingWeight": "Remaining Weight (KG)",
    "requestPallet": "Request Pallet (PCS)",
    "remainingPallet": "Remaining Pallet (PCS)",
    "fee": "Fee",
    "bill": "Bill",
    "sealno": "Container/ Seal No.",
    "blno": "B/L No.",
    "vesselname": "Vessel Name",
    "shipmentRequest": "Shipment Certificate Request",
    "shipmentInfo": "Basic information for this shipment certificate request.",
    "consigneeName": "Name of Consignee",
    "portLoading": "Port of Loading",
    "finalDestination": "Final Destination",
    "shipmentPackaging": "Shipment Packaging",
    "clientReference": "Client Reference",
    "shipper": "Shipper",
    "treatmentMonitoringAlarm": "View alarms and check for solutions.",
    "parameters": "Parameters",
    "proceedTime": "Proceed Time",
    "dataLog": "Data Log",
    "changeChart": "Change Chart",
    "selected": "Selected",
    "value": "Value",
    "proceedTimeHHmm": "Proceed Time (HH:MM)",
    "find": "Find",
    "shipmentWeight": "Add weight for shipment certificate",
    "shipmentWithoutWeight": "Don’t add weight for shipment certificate",
    "alarmType": "Alarm Type",
    "date": "Date",
    "time": "Time",
    "draft": "Draft",
    "send": "Send",
    "sendAgain": "Send Again",
    "free": "Free",
    "notFree": "Not Free",
    "approve": "Approve",
    "reject": "Reject",
    "viewTreatmentID": "View Treatment ID",
    "registrationDate": "Registration Date",
    "Waiting": "Waiting",
    "Activated": "Activated",
    "Deactivated": "Deactivated",
    "reviewTitle": "Please review the about us before public",
    "recordData":"Record Data",
    "graph":"Graph",
    "rpaName": "RPA Name",
    "RPAGeneralInformation": "RPA General Information",
    "since": "Since",
    "conditionType": "Condition Type",
    "comparison": "Comparison",
    "otherVariable": "Other Variable",
    "after": "After",
    "endCheckingAfter": "End Checking After",
    "afterEveryInterval": "After every interval",
    "afterEveryIntervalEndPhase": "After every interval to end of phase",
    "phaseOne": "Phase 1: Before Starting Treatment",
    "phaseTwo": "Phase 2: Start Treatment - Before reaching setpoint",
    "phaseThree": "Phase 3: Maintaining Treatment",
    "phaseFour": "Phase 4: After Stopping Treatment",
    "beginThePhase": "Begin the Phase",
    "range": "Range",
    "Down": "Down",
    "Up": "Up",
    "technicalChecking": "Technical checking",
    "waitingTechnicalChecking": "Waiting Technical Checking to Start",
    "reachingSetpointExpectedEndTime": "Reaching setpoint & Expected end time",
    "recountTreatmentTime": "Recount treatment time",
    "addTime": "Add Time",
    "removeTime": "Remove Time",
    "otherRpa": "Other RPA",
    "treatmentRpa": "Treatment RPA",
    "otherRules": "Other Rules",
    "selectDataTemplate": "Select Data Template",
    "selectTemplate": "Select Template",
    "rule": "Rule",
    "from": "From",
    "to": "To",
    "sinceABool": "Since a bool variable is On",
    "ruleName": "Rule Name",
    "orderNo": "Sort no",
    "True": "True",
    "False": "False",
    "fromOpenDate": "From Open Date",
    "toOpenDate": "To Open Date",
    "stopTreatment": "Stop Treatment",
    "weightSetting": "WEIGHT SETTING",
    "addWeightForShipmentCertificate": "Add weight for shipment certificate",
    "dontAddWeightForShipmentCertificate": "Don't add weight for shipment certificate",
    "stopSetting": "STOP SETTING",
    "stopImmediately": "Stop Immediately",
    "autostopDate": "Autostop Date",
    "shipmentCertificateWeight": "Shipment Certificate Weight",
    "startImmediately": "Start Immediately",
    "treatmentTypes": "Treatment Types",
    "password": "Password",
    "confirmPassword": "Confirm password",
    "fullNameEmail": "Full Name, Email, Password",
    "Box": "Box",
    "Boxes": "Boxes",
    "numberParameter": "Select Parameter",
    "boolParameter":"On / Off Parameter",
    "startTime": "Start Time",
    "endTime": "End Time",
    "treatmentID": "Treatment ID",
    "licenseInformation": "License information",
    "activateLicense": "Activate license",
    "connect": "Connect",
    "locationId":"Location ID",
    "enterLocationId":"Please enter the Location ID",
    "syncSuccess":"Connected successfully to ECO2 Web Server",
    "syncInProgress":"The data synchronization with ECO2 Web Server is in-progress. Please wait until it is finished",
    "Color": "Color",
	  "allLocations": "All locations",
    "specificLocations": "Specific locations",
    "appliedTo": "Applied To",
    "expiryTime": "Expiry Time",
    "viewDetail": "View Detail",
    "appliedLocations": "Applied Locations",
    "selectLocation": "Select Location",
    "treatmentGraph": "Treatment Graph",
    "pallet": "Pallet",
    "yes": "Yes",
    "registration": "Registration",
    "registrationNo": "Registration No",
    "shipmentFreetimes": "Shipment free times number",
    "validRemainingWeight": "Valid Remaining Weight (KG)",
    "invalidRemainingWeight": "Invalid Remaining Weight (KG)",
    "validRemainingPallet": "Valid Remaining Pallet (PCS)",
    "invalidRemainingPallet": "Invalid Remaining Pallet (PCS)",
    "issueDateSuggestion": "Issue Date Suggestion!",
    "desiredIssueDate": "Desired Issue Date",
    "cancel": "Cancel",
    "approveShipmentCertificate": "Approve Shipment Certificate",
    "cancelShipmentCertificate": "Cancel Shipment Certificate",
    "rejectShipmentCertificate": "Reject Shipment Certificate",
    "totalRequestWeight": "Total Request (KG)/(PCS)",
    "totalRemainingWeight": "Total Remaining (KG)/(PCS)",
    "durationTreatment" :"Duration Treatment",
    "durationTemperature": "Duration Reach Temperature",
    "durationReachO2": "Duration Reach O2 Level",
    "condition": "Condition",
    "reachingO2Level": "Reach O2 Level",
    "reachingProductTemp": "Reach Temperature",
    "startTemperature": "Start Temperature",
    "logOut": "Log out",
    "packing": "Packing",
    "resetOperatingTime": "Reset Operating Time",
    "finish": "Finish",
    "webConfig": "Web Config",
    "graphAddress": "Graph-Address",
    "graphPhone": "Graph-Phone",
    "graphEmail": "Graph-Email",
    "foreignStamp": "Foreign Stamp",
    "vietNamStamp": "Vietnam Stamp",
    "palletCondition": "Pallet Condition",
    "commoditiesCondition": "Commodities Condition",
    "disableSendEmailToAdmin": "Disable sending email to Administrator",
    "graphWebsite": "Graph-Website",
    "graphFooter": "Graph-Footer",
    "certificate": "Certificate",
    "treatmentProvider": "Treatment-Provider",
    "treatmentSupervisor": "Treatment-Supervisor",
    "filter": 'Filter',
    "overview": 'Overview',
    "page-not-found": "Page Not Found",
    "page-not-found-description": "Oops! The page you're looking for doesn't exist. It might have been moved, deleted, or you entered the wrong URL.",
    "page-not-found-go-back": "Go Back",
    "sign-in": "Sign In",
    "welcome-back": "Welcome back!",
    "email-field": "Email",
    "enter-your-email": "Enter your email",
    "email-is-required": "Email is required",
    "password-field": "Password",
    "enter-your-password": "Enter your password",
    "password-is-required": "Password is required",
    "or": "or",
    "sign-in-ms": "Sign in with PCU Account",
    "email-must-be-valid": "Email must be valid",
    "password-length": "Password must be at least 8 characters",
    "reset-password": "Reset Password",
    "Please-enter-reset-password": "Please enter your new password for your account.",
    "new-password": "New Password",
    "enter-new-password": "Enter new password",
    "confirm-password": "Confirm password",
    "confirm-new-password": "Confirm new password",
    "confirm-password-is-required": "Confirm password is required",
    "passwords-do-not-match": "Passwords do not match",
    "token-invalid-or-expired": "Token is invalid or expired",
    "invalid-email-or-password": "Invalid email or password",
    "notifications": "Notifications",
    "forgot-password": "Forgot Password",
  },
  "treatment": {
    "add": "Add Treatment Database",
    "edit": "Edit Treatment Database",
    "view": "Treatment Database",
    "master_list": "MASTER LIST",
    "database": "DATABASE",
    "status": {
      "Active": "Active",
      "Inactive": "Inactive"
    }
  },
  "unitColumn": {
    "name": "Name",
    "type": "Type",
    "rpa": "RPA",
    "description": "Description",
    "variables": "Variables",
    "freeText": "Free text",
    "toleranceOutreachTemp": "Temperature tolerance outreach",
    "toleranceOutreachO2": "O2 tolerance outreach"
  },
  "license": {
    "edit": "EDIT ABOUT US",
    "buttonPublic": "PUBLIC ABOUT US",
    "reviewText": "Please review the about us before public",
  },
  "rpaTemplate": {
    "templateOne": {
      "since": "- Begin the phase\n - Range from - to",
      "sinceABool": "Variable",
      "variable": "Variable",
      "type": "Byte/UByte/Word/Floating",
      "conditionType": "Down / Up",
      "comparison": ">= / > / = / < / <=",
      "value": "Number",
      "after": "- After\n - After every interval\n - After every interval to end of phase",
      "time": "Time",
      "package": "Package",
    },
    "templateTwo": {
      "since": "- Begin the phase",
      "sinceABool": "Variable",
      "variable": "Variable",
      "type": "Byte/UByte/Word/Floating",
      "conditionType": "",
      "comparison": ">= / > / = / < / <=",
      "value": "Other Variable\n(+/- Number)",
      "after": "- After\n - After every interval\n - After every interval to end of phase",
      "time": "Time",
      "package": "Package",
    },
    "templateThree": {
      "since": "- Begin the phase",
      "sinceABool": "Variable",
      "variable": "Variable",
      "type": "Bool",
      "conditionType": "Is",
      "comparison": "",
      "value": "True/False",
      "after": "- After\n - After every interval\n - After every interval to end of phase",
      "time": "Time",
      "package": "Package",
    }
  },
  "status": {
    "OPEN": "Open",
    "CLOSED": "Closed",
    "INREQUEST": "In Request",
    "REJECTED": "Rejected",
    "APPROVED": "Approved",
    "DRAFT": "Draft",
    "VALID": "Valid",
    "CANCELED": "Canceled",
    "ACCEPTED": "Accepted",
    "NEEDSUPPORT": "Need Support",
    "NEW": "New",
    "OVERDUE": "Overdue",
    "FINISHED": "Finished",
  },
  "shipmentCertificateForm": {
    "maxDesiredIssueDate": "Desired Issue Date can't be after Maximum Shipment Issue Date <%= maxDate %>",
    "minDesiredIssueDate": "Desired Issue Date can't be before Minimum Shipment Issue Date <%= minDate %>",
  },
  "webConfig": {

  }
};
